import { type CredentialType } from '@models/entities/credentials'
import { type PointType } from '@models/entities/points'
import { FeeAccrualTypes } from '@models/entities/fees'
import {
  TransactionStatuses,
  TransactionTypes,
  TransactionEntryStatuses,
  type TransactionType
} from '@models/entities/transactions'
import {
  SettlementStatuses,
  type SettlementType
} from '@models/entities/settlements'
import { LanguageList } from '@models/entities/languages'
import { PaymentMethods } from '@models/entities/payment'
import { CreateInvoiceFormFields } from '@models/forms/createInvoice'
import {
  TimeFormats,
  DateFormats,
  NumberSeparators
} from '@models/entities/settings'

const credentials_list: CredentialType[] = [
  {
    id: 1,
    alias: 'Magazin1',
    created_date: '2025-08-17T18:16:37.284578',
    key: 'client2047857493',
    secret: 'ev354_dm!3+Nlf)3'
  },
  {
    id: 2,
    alias: 'Magazin2',
    created_date: '2025-08-18T14:26:53.284578',
    key: 'client2047857494',
    secret: 'bk836$cg$1-Mkx(4'
  },
  {
    id: 3,
    alias: 'Magazin3',
    created_date: '2025-08-19T08:45:42.284578',
    key: 'client2047857495',
    secret: 'hj749-bm&3*Cvr[7'
  },
  {
    id: 4,
    alias: 'Magazin4',
    created_date: '2025-08-20T10:11:14.284578',
    key: 'client2047857496',
    secret: 'lk268^nw?4@Nos]8'
  }
]

const point_list: PointType[] = [
  {
    code: 'pt-001',
    created_date: '2025-09-25T12:06:40.284578+03:00',
    name: 'The Grand Mall of Shiva',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00',
      hold: '1500.00',
      payout: '1293.00',
      rolling: '1500.00'
    },
    status: 'online',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '20.00',
        max_val: '1800.00',
        required_fields: [
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME,
          CreateInvoiceFormFields.BANK_CODE
        ],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET
        ],
        fields_choices: {
          bank_code: [
            'sber',
            'vtb',
            'tbank'
          ]
        }
      }
    ],
    fees: {
      payment: [
        {
          accrual_type: FeeAccrualTypes.INTERNAL,
          percent: '2.50',
          fixed: '1.00',
          min_fixed: '0.50',
          max_fixed: '3.00',
          method: null,
          terminal: null
        },
        {
          accrual_type: FeeAccrualTypes.INTERNAL,
          percent: '3.10',
          fixed: '1.50',
          min_fixed: '0.75',
          max_fixed: '5.00',
          method: 'card',
          terminal: null
        },
        {
          accrual_type: FeeAccrualTypes.INTERNAL,
          percent: '1.20',
          fixed: '0.30',
          min_fixed: '0.10',
          max_fixed: '2.00',
          method: 'upi',
          terminal: 'terminal-01'
        }
      ],
      payout: [
        {
          accrual_type: FeeAccrualTypes.INTERNAL,
          percent: '1.80',
          fixed: '0.50',
          min_fixed: '0.25',
          max_fixed: '2.00',
          method: null,
          terminal: null
        },
        {
          accrual_type: FeeAccrualTypes.INTERNAL,
          percent: '2.00',
          fixed: '1.00',
          min_fixed: '0.50',
          max_fixed: '4.00',
          method: 'bank_transfer',
          terminal: null
        }
      ],
      rolling: {
        percent: '2.50',
        cap: '30000.00'
      }
    }
  },
  {
    code: 'pt-002',
    created_date: '2025-08-21T14:12:42.284578+03:00',
    name: 'Gift Cards Store',
    balance: {
      currency: 'GBP',
      total: '7987657.78',
      base: '7987000.00',
      hold: '657.00'
    },
    status: 'offline',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '10.00',
        max_val: '28050.20',
        required_fields: [
          CreateInvoiceFormFields.USER_ID
        ],
        additional_fields: [
          CreateInvoiceFormFields.ADDRESS,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '100.00',
        max_val: '179452.70',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.POSTAL_CODE
        ]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '950.40',
        max_val: '1245280.45',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME
        ],
        additional_fields: []
      }
    ],
    fees: {
      payment: [
        {
          accrual_type: FeeAccrualTypes.INTERNAL,
          percent: '3.00',
          fixed: '2.00',
          min_fixed: '1.00',
          max_fixed: '5.00',
          method: 'card',
          terminal: null
        },
        {
          accrual_type: FeeAccrualTypes.INTERNAL,
          percent: '1.50',
          fixed: '0.75',
          min_fixed: '0.30',
          max_fixed: '4.00',
          method: 'upi',
          terminal: null
        }
      ]
    }
  },
  {
    code: 'pt-003',
    created_date: '2025-09-11T16:17:19.284578+03:00',
    name: 'Madagascarian “Islanders” Car Rent',
    balance: {
      currency: 'UZS',
      total: '98873.17',
      base: '97000.00',
      payout: '1273.17',
      rolling: '600.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.UPI,
        min_val: '140.26',
        max_val: '680.99',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.COUNTRY_CODE
        ],
        additional_fields: [CreateInvoiceFormFields.ADDRESS]
      }
    ]
  },
  {
    code: 'pt-004',
    created_date: '2025-09-20T10:45:11.184321+03:00',
    name: 'Lotus Electronics Hub',
    balance: {
      currency: 'USD',
      total: '432198.55',
      base: '430000.00',
      rolling: '2198.55'
    },
    status: 'online',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '125.04',
        max_val: '2740.27',
        required_fields: [],
        additional_fields: [CreateInvoiceFormFields.EMAIL]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '250.41',
        max_val: '14927831.16',
        required_fields: [CreateInvoiceFormFields.PHONE],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-005',
    created_date: '2025-07-30T08:05:33.552189+03:00',
    name: 'Travel Tickets Office',
    balance: {
      currency: 'EUR',
      total: '213456.90',
      base: '210000.00',
      payout: '3456.90'
    },
    status: 'offline',
    payment_methods: [
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '270.00',
        max_val: '2945129.28',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET,
          CreateInvoiceFormFields.POSTAL_CODE,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '15.20',
        max_val: '7549.75',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME,
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.BIRTH_DATE
        ],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-006',
    created_date: '2025-09-14T19:25:40.994221+03:00',
    name: 'Island Café and Rent',
    balance: {
      currency: 'RUB',
      total: '58493.33',
      base: '57000.00',
      hold: '493.00',
      payout: '1000.33'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '20.00',
        max_val: '1800.00',
        required_fields: [
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME
        ],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET
        ]
      }
    ]
  },
  {
    code: 'pt-007',
    created_date: '2025-09-10T17:55:22.741258+03:00',
    name: 'Golden Bazaar',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00',
      hold: '1500.00',
      payout: '1293.00',
      rolling: '1500.00'
    },
    status: 'online',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '10.00',
        max_val: '28050.20',
        required_fields: [
          CreateInvoiceFormFields.USER_ID
        ],
        additional_fields: [
          CreateInvoiceFormFields.ADDRESS,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '100.00',
        max_val: '179452.70',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.POSTAL_CODE
        ]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '950.40',
        max_val: '1245280.45',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME
        ],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-008',
    created_date: '2025-08-01T12:30:42.128453+03:00',
    name: 'Digital Codes Market',
    balance: {
      currency: 'GBP',
      total: '7987657.78',
      base: '7987000.00',
      hold: '657.00'
    },
    status: 'offline',
    payment_methods: [
      {
        name: PaymentMethods.UPI,
        min_val: '140.26',
        max_val: '680.99',
        required_fields: [CreateInvoiceFormFields.USER_ID],
        additional_fields: [CreateInvoiceFormFields.ADDRESS]
      }
    ]
  },
  {
    code: 'pt-009',
    created_date: '2025-09-13T16:18:44.662134+03:00',
    name: 'African Car Rental',
    balance: {
      currency: 'UZS',
      total: '98873.17',
      base: '97000.00',
      payout: '1273.17',
      rolling: '600.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '125.04',
        max_val: '2740.27',
        required_fields: [],
        additional_fields: [CreateInvoiceFormFields.EMAIL]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '250.41',
        max_val: '14927831.16',
        required_fields: [CreateInvoiceFormFields.PHONE],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-010',
    created_date: '2025-09-18T15:11:55.332891+03:00',
    name: 'Shiva Plaza',
    balance: {
      currency: 'USD',
      total: '432198.55',
      base: '430000.00',
      rolling: '2198.55'
    },
    status: 'online',
    payment_methods: [
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '270.00',
        max_val: '2945129.28',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET,
          CreateInvoiceFormFields.POSTAL_CODE,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '15.20',
        max_val: '7549.75',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME,
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.BIRTH_DATE
        ],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-011',
    created_date: '2025-08-05T11:11:11.987654+03:00',
    name: 'Gift Hub',
    balance: {
      currency: 'EUR',
      total: '213456.90',
      base: '210000.00',
      payout: '3456.90'
    },
    status: 'offline',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '20.00',
        max_val: '1800.00',
        required_fields: [
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME
        ],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET
        ]
      }
    ]
  },
  {
    code: 'pt-012',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Test',
    balance: {
      currency: 'RUB',
      total: '58493.33',
      base: '57000.00',
      hold: '493.00',
      payout: '1000.33'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '10.00',
        max_val: '28050.20',
        required_fields: [
          CreateInvoiceFormFields.USER_ID
        ],
        additional_fields: [
          CreateInvoiceFormFields.ADDRESS,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '100.00',
        max_val: '179452.70',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.POSTAL_CODE
        ]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '950.40',
        max_val: '1245280.45',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME
        ],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-013',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Hello',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.UPI,
        min_val: '140.26',
        max_val: '680.99',
        required_fields: [CreateInvoiceFormFields.USER_ID],
        additional_fields: [CreateInvoiceFormFields.ADDRESS]
      }
    ]
  },
  {
    code: 'pt-014',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Ass',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '125.04',
        max_val: '2740.27',
        required_fields: [],
        additional_fields: [CreateInvoiceFormFields.EMAIL]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '250.41',
        max_val: '14927831.16',
        required_fields: [CreateInvoiceFormFields.PHONE],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-015',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Arab',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '270.00',
        max_val: '2945129.28',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET,
          CreateInvoiceFormFields.POSTAL_CODE,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '15.20',
        max_val: '7549.75',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME,
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.BIRTH_DATE
        ],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-016',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Mobile',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '20.00',
        max_val: '1800.00',
        required_fields: [
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME
        ],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET
        ]
      }
    ]
  },
  {
    code: 'pt-017',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Haustier',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '10.00',
        max_val: '28050.20',
        required_fields: [
          CreateInvoiceFormFields.USER_ID
        ],
        additional_fields: [
          CreateInvoiceFormFields.ADDRESS,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '100.00',
        max_val: '179452.70',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.POSTAL_CODE
        ]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '950.40',
        max_val: '1245280.45',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME
        ],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-018',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Arab',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.UPI,
        min_val: '140.26',
        max_val: '680.99',
        required_fields: [CreateInvoiceFormFields.USER_ID],
        additional_fields: [CreateInvoiceFormFields.ADDRESS]
      }
    ]
  },
  {
    code: 'pt-019',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Mobile',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD,
        min_val: '125.04',
        max_val: '2740.27',
        required_fields: [],
        additional_fields: [CreateInvoiceFormFields.EMAIL]
      },
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '250.41',
        max_val: '14927831.16',
        required_fields: [CreateInvoiceFormFields.PHONE],
        additional_fields: []
      }
    ]
  },
  {
    code: 'pt-020',
    created_date: '2025-09-09T09:29:59.445566+03:00',
    name: 'Oceanic Haustier',
    balance: {
      currency: 'INR',
      total: '12431793.00',
      base: '12427500.00'
    },
    status: 'test',
    payment_methods: [
      {
        name: PaymentMethods.CARD_TRANSFER,
        min_val: '270.00',
        max_val: '2945129.28',
        required_fields: [],
        additional_fields: [
          CreateInvoiceFormFields.COUNTRY_CODE,
          CreateInvoiceFormFields.CITY,
          CreateInvoiceFormFields.STREET,
          CreateInvoiceFormFields.POSTAL_CODE,
          CreateInvoiceFormFields.BIRTH_DATE
        ]
      },
      {
        name: PaymentMethods.UPI,
        min_val: '15.20',
        max_val: '7549.75',
        required_fields: [
          CreateInvoiceFormFields.USER_ID,
          CreateInvoiceFormFields.FIRST_NAME,
          CreateInvoiceFormFields.SURNAME,
          CreateInvoiceFormFields.EMAIL,
          CreateInvoiceFormFields.PHONE,
          CreateInvoiceFormFields.BIRTH_DATE
        ],
        additional_fields: []
      }
    ]
  }
]

const transaction_list: TransactionType[] = [
  {
    id: 'tx-01-9f3a7c2e-1b44-4c11-a001-000000000001',
    channel_code: 'pt-015',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: TransactionStatuses.NEW,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD,
    postings: [
      {
        created_date: '2025-08-06T16:53:34.404Z',
        status: TransactionEntryStatuses.DEPOSIT,
        amount: '50.00',
        fee: '77.50',
        charged: '22.50'
      },
      {
        created_date: '2025-08-05T16:53:34.404Z',
        status: TransactionEntryStatuses.HOLD,
        amount: '25.00',
        fee: '0',
        charged: '0'
      },
      {
        created_date: '2025-08-04T16:53:34.404Z',
        status: TransactionEntryStatuses.UNHOLD,
        amount: '25.00',
        fee: '0',
        charged: '0'
      }
    ],
    payer: {
      first_name: { source: 'hosted', value: 'Ivan' },
      last_name: { source: 's2s', value: 'Ivanov' },
      surname: { source: 's2s', value: 'Ivanovich' },
      user_id: { source: 'hosted', value: 'fjhgbirbg4-4362hfg' },
      birth_date: { source: 'hosted', value: '2000-03-17T12:14:28.404Z' },
      document_type: { source: 'hosted', value: 'Pasport' },
      document: { source: 'hosted', value: '7089 238418' },
      phone: { source: 's2s', value: '+7-547-278-37-11' },
      email: { source: 'hosted', value: 'ivanmail-god@rambler.ru' },
      user_ip: { source: 's2s', value: '103.115.96.225' },
      address: { source: 's2s', value: 'Russia, Tverskaya obl., Solnechniy city, Polevaya St., 67' },
      country: { source: 'hosted', value: 'Russia' },
      country_code: { source: 'hosted', value: 'RU' },
      state: { source: 'hosted', value: 'Tverskaya obl.' },
      city: { source: 's2s', value: 'Solnechniy' },
      street: { source: 'hosted', value: 'Polevaya' },
      postal_code: { source: 'hosted', value: 'B4 7NJ' },
      cpf: { source: 's2s', value: 'fdrhg389-2754' },
      iban: { source: 's2s', value: 'GB29 NWBK 6016 1331 9268 19' }
    }
  },
  {
    id: 'tx-02-9f3a7c2e-1b44-4c11-a001-000000000002',
    channel_code: 'pt-016',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: TransactionStatuses.NEW,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD,
    postings: [
      {
        created_date: '2025-08-07T10:53:34.404Z',
        status: TransactionEntryStatuses.DEPOSIT,
        amount: '200.00',
        fee: '37.00',
        charged: '200.00'
      },
      {
        created_date: '2025-08-06T16:53:34.404Z',
        status: TransactionEntryStatuses.HOLD,
        amount: '10.00',
        fee: '0',
        charged: '0'
      },
      {
        created_date: '2025-08-06T16:43:34.404Z',
        status: TransactionEntryStatuses.UNHOLD,
        amount: '10.00',
        fee: '0',
        charged: '0'
      },
      {
        created_date: '2025-08-05T18:53:34.404Z',
        status: TransactionEntryStatuses.PAYOUT,
        amount: '10.00',
        fee: '0',
        charged: '0'
      },
      {
        created_date: '2025-08-05T14:23:34.404Z',
        status: TransactionEntryStatuses.CANCELLED_PAYOUT,
        amount: '7.00',
        fee: '0',
        charged: '0'
      }
    ],
    payer: {
      first_name: { source: 's2s', value: 'Ivan' },
      last_name: { source: 'hosted', value: 'Ivanov' },
      surname: { source: 's2s', value: 'Ivanovich' },
      user_id: { source: 'hosted', value: 'fjhgbirbg4-4362hfg' },
      birth_date: { source: 'hosted', value: '2000-03-17T12:14:28.404Z' },
      document_type: { source: 's2s', value: 'Pasport' },
      document: { source: 'hosted', value: '7089 238418' },
      phone: { source: 'hosted', value: '+7-547-278-37-11' },
      email: { source: 'hosted', value: 'ivanmail-god@rambler.ru' },
      user_ip: { source: 's2s', value: '103.115.96.225' },
      postal_code: { source: 'hosted', value: 'B4 7NJ' }
    }
  },
  {
    id: 'tx-03-9f3a7c2e-1b44-4c11-a001-000000000003',
    channel_code: 'pt-017',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: TransactionStatuses.NEW,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD,
    postings: [
      {
        created_date: '2025-08-07T10:53:34.404Z',
        status: TransactionEntryStatuses.DEPOSIT,
        amount: '114000.26',
        fee: '1250.26',
        charged: '122250.00'
      },
      {
        created_date: '2025-08-06T16:53:34.404Z',
        status: TransactionEntryStatuses.HOLD,
        amount: '9000.00',
        fee: '0',
        charged: '0'
      },
      {
        created_date: '2025-08-06T13:53:34.404Z',
        status: TransactionEntryStatuses.CANCELLED_PAYOUT,
        amount: '1000.26',
        fee: '0',
        charged: '0'
      }
    ],
    payer: {}
  },
  {
    id: 'tx-04-9f3a7c2e-1b44-4c11-a001-000000000004',
    channel_code: 'pt-018',
    external_id: null,
    callback_sent: true,
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: TransactionStatuses.COMPLETED,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD,
    postings: [
      {
        created_date: '2025-08-06T16:53:34.404Z',
        status: TransactionEntryStatuses.DEPOSIT,
        amount: '100.00',
        fee: '19.99',
        charged: '80.01'
      },
      {
        created_date: '2025-08-05T16:53:34.404Z',
        status: TransactionEntryStatuses.HOLD,
        amount: '0',
        fee: '0',
        charged: '0'
      },
      {
        created_date: '2025-08-04T16:53:34.404Z',
        status: TransactionEntryStatuses.PAYOUT,
        amount: '0',
        fee: '0',
        charged: '0'
      }
    ],
    payer: {}
  },
  {
    id: 'tx-05-9f3a7c2e-1b44-4c11-a001-000000000005',
    channel_code: 'pt-011',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: TransactionStatuses.NEW,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD_TRANSFER,
    postings: [],
    payer: {}
  },
  {
    id: 'tx-06-9f3a7c2e-1b44-4c11-a001-000000000006',
    channel_code: 'pt-012',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: TransactionStatuses.NEW,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.UPI,
    postings: [],
    payer: {}
  },
  {
    id: 'tx-07-9f3a7c2e-1b44-4c11-a001-000000000007',
    channel_code: 'pt-013',
    external_id: null,
    callback_sent: true,
    created_date: '2025-08-07T10:59:41.284578+03:00',
    updated_date: '2025-08-07T13:12:18.284578+03:00',
    amount: { currency: 'USD', value: '1581.12' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: TransactionStatuses.FAILED,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD_TRANSFER,
    postings: [],
    payer: {}
  },
  {
    id: 'tx-08-9f3a7c2e-1b44-4c11-a001-000000000008',
    channel_code: 'pt-014',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-06T12:42:23.284578+03:00',
    updated_date: '2025-08-06T12:46:45.284578+03:00',
    amount: { currency: 'BDT', value: '36789.17' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: TransactionStatuses.PROCESSING,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD,
    postings: [],
    payer: {}
  },
  {
    id: 'tx-09-9f3a7c2e-1b44-4c11-a001-000000000009',
    channel_code: 'pt-009',
    external_id: null,
    callback_sent: false,
    created_date: '2025-08-06T06:24:18.284578+03:00',
    updated_date: '2025-08-06T06:26:24.284578+03:00',
    amount: { currency: 'IDR', value: '123681.27' },
    fee: '289.04',
    charged: '123380.23',
    point: 'Gift Cards Store',
    status: TransactionStatuses.COMPLETED,
    type: TransactionTypes.PAYOUT,
    method: PaymentMethods.CARD,
    postings: [
      {
        created_date: '2025-08-06T06:13:34.404Z',
        status: TransactionEntryStatuses.DEPOSIT,
        amount: '50.00',
        fee: '77.50',
        charged: '22.50'
      },
      {
        created_date: '2025-08-05T16:53:34.404Z',
        status: TransactionEntryStatuses.HOLD,
        amount: '25.00',
        fee: '0',
        charged: '0'
      },
      {
        created_date: '2025-08-04T16:53:34.404Z',
        status: TransactionEntryStatuses.UNHOLD,
        amount: '25.00',
        fee: '0',
        charged: '0'
      }
    ],
    payer: {}
  },
  {
    id: 'tx-10-9f3a7c2e-1b44-4c11-a001-000000000010',
    channel_code: 'pt-011',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: TransactionStatuses.NEW,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.UPI,
    postings: [],
    payer: {}
  },
  {
    id: 'tx-11-9f3a7c2e-1b44-4c11-a001-000000000011',
    channel_code: 'pt-011',
    external_id: null,
    callback_sent: false,
    created_date: '2025-08-07T10:59:41.284578+03:00',
    updated_date: '2025-08-07T13:12:18.284578+03:00',
    amount: { currency: 'USD', value: '1581.12' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: TransactionStatuses.FAILED,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.UPI,
    postings: [],
    payer: {}
  },
  {
    id: 'tx-12-9f3a7c2e-1b44-4c11-a001-000000000012',
    channel_code: 'pt-011',
    external_id: null,
    callback_sent: null,
    created_date: '2025-08-06T12:42:23.284578+03:00',
    updated_date: '2025-08-06T12:46:45.284578+03:00',
    amount: { currency: 'BDT', value: '36789.17' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: TransactionStatuses.PROCESSING,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.UPI,
    postings: [],
    payer: {}
  },
  {
    id: 'tx-13-9f3a7c2e-1b44-4c11-a001-000000000013',
    channel_code: 'pt-011',
    external_id: null,
    callback_sent: false,
    created_date: '2025-08-06T06:24:18.284578+03:00',
    updated_date: '2025-08-06T06:26:24.284578+03:00',
    amount: { currency: 'IDR', value: '123681.27' },
    fee: '289.04',
    charged: '123380.23',
    point: 'Gift Cards Store',
    status: TransactionStatuses.COMPLETED,
    type: TransactionTypes.PAYMENT,
    method: PaymentMethods.CARD,
    postings: [],
    payer: {}
  }
]

const settlement_list: SettlementType[] = [
  {
    id: 'tx-01-9f3a7c2e-1b44-4c11-a001-000000000001',
    channel_code: 'pt-015',
    external_id: null,
    request_id: '5573659',
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: SettlementStatuses.NEW
  },
  {
    id: 'tx-02-9f3a7c2e-1b44-4c11-a001-000000000002',
    channel_code: 'pt-016',
    external_id: null,
    request_id: '5583959',
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: SettlementStatuses.NEW
  },
  {
    id: 'tx-03-9f3a7c2e-1b44-4c11-a001-000000000003',
    channel_code: 'pt-017',
    external_id: null,
    request_id: '5583915',
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: SettlementStatuses.NEW
  },
  {
    id: 'tx-04-9f3a7c2e-1b44-4c11-a001-000000000004',
    channel_code: 'pt-018',
    external_id: null,
    request_id: '5583948',
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: SettlementStatuses.COMPLETED
  },
  {
    id: 'tx-05-9f3a7c2e-1b44-4c11-a001-000000000005',
    channel_code: 'pt-011',
    external_id: null,
    request_id: '5581739',
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: SettlementStatuses.NEW
  },
  {
    id: 'tx-06-9f3a7c2e-1b44-4c11-a001-000000000006',
    channel_code: 'pt-012',
    external_id: null,
    request_id: '5582739',
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: SettlementStatuses.NEW
  },
  {
    id: 'tx-07-9f3a7c2e-1b44-4c11-a001-000000000007',
    channel_code: 'pt-013',
    external_id: null,
    request_id: '5594376',
    created_date: '2025-08-07T10:59:41.284578+03:00',
    updated_date: '2025-08-07T13:12:18.284578+03:00',
    amount: { currency: 'USD', value: '1581.12' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: SettlementStatuses.FAILED
  },
  {
    id: 'tx-08-9f3a7c2e-1b44-4c11-a001-000000000008',
    channel_code: 'pt-014',
    external_id: null,
    request_id: '5594338',
    created_date: '2025-08-06T12:42:23.284578+03:00',
    updated_date: '2025-08-06T12:46:45.284578+03:00',
    amount: { currency: 'BDT', value: '36789.17' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: SettlementStatuses.PROCESSING
  },
  {
    id: 'tx-09-9f3a7c2e-1b44-4c11-a001-000000000009',
    channel_code: 'pt-009',
    external_id: null,
    request_id: '5594317',
    created_date: '2025-08-06T06:24:18.284578+03:00',
    updated_date: '2025-08-06T06:26:24.284578+03:00',
    amount: { currency: 'IDR', value: '123681.27' },
    fee: '289.04',
    charged: '123380.23',
    point: 'Gift Cards Store',
    status: SettlementStatuses.COMPLETED
  },
  {
    id: 'tx-10-9f3a7c2e-1b44-4c11-a001-000000000010',
    channel_code: 'pt-011',
    external_id: null,
    request_id: '5594482',
    created_date: '2025-08-07T11:00:59.284578+03:00',
    updated_date: '2025-08-07T14:32:44.284578+03:00',
    amount: { currency: 'RUB', value: '1685392.06' },
    fee: '127.14',
    charged: '178927.26',
    point: 'The Grand Mall of Shiva',
    status: SettlementStatuses.NEW
  },
  {
    id: 'tx-11-9f3a7c2e-1b44-4c11-a001-000000000011',
    channel_code: 'pt-011',
    external_id: null,
    request_id: '5594484',
    created_date: '2025-08-07T10:59:41.284578+03:00',
    updated_date: '2025-08-07T13:12:18.284578+03:00',
    amount: { currency: 'USD', value: '1581.12' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: SettlementStatuses.FAILED
  },
  {
    id: 'tx-12-9f3a7c2e-1b44-4c11-a001-000000000012',
    channel_code: 'pt-011',
    external_id: null,
    request_id: '5594493',
    created_date: '2025-08-06T12:42:23.284578+03:00',
    updated_date: '2025-08-06T12:46:45.284578+03:00',
    amount: { currency: 'BDT', value: '36789.17' },
    fee: '18.93',
    charged: '1280.26',
    point: 'Gift Cards Store',
    status: SettlementStatuses.PROCESSING
  },
  {
    id: 'tx-13-9f3a7c2e-1b44-4c11-a001-000000000013',
    channel_code: 'pt-011',
    external_id: null,
    request_id: '5594497',
    created_date: '2025-08-06T06:24:18.284578+03:00',
    updated_date: '2025-08-06T06:26:24.284578+03:00',
    amount: { currency: 'IDR', value: '123681.27' },
    fee: '289.04',
    charged: '123380.23',
    point: 'Gift Cards Store',
    status: SettlementStatuses.COMPLETED
  }
]

const user_mock = {
  id: 111,
  name: 'Username 111',
  email: 'user@gmail.com',
  company: {
    name: 'My Finance Company',
    created_date: '2025-08-30T16:42:47Z',
    portal_ip_whitelist_enabled: true,
    api_ip_whitelist_enabled: false,
    portal_ip_whitelist: [
      {
        ip: '192.168.1.1',
        created_by_name: 'Ivan Ivanov',
        created_by_email: 'ivan@example.com',
        created_at: '2026-07-14T12:30:45.123456+00:00'
      },
      {
        ip: '192.164.1.2',
        created_by_name: 'Semen Semenov',
        created_by_email: 'semen@example.com',
        created_at: '2026-07-15T11:30:21.123456+00:00'
      },
      {
        ip: '190.162.2.3',
        created_by_name: 'Evgeniy Evgenyev',
        created_by_email: 'evgeniy@example.com',
        created_at: '2026-07-15T14:47:53.123456+00:00'
      }
    ],
    api_ip_whitelist: [
      {
        ip: '142.119.2.1',
        created_by_name: 'Roman Romanov',
        created_by_email: 'ivan@example.com',
        created_at: '2026-07-14T12:30:45.123456+00:00'
      }
    ]
  },
  registered_date: '2025-08-29T10:10:00Z',
  lang: LanguageList.RU,
  login_mfa: false,
  user_permissions: {
    salepoints: [
      {
        code: 'pt-001',
        checked: true
      },
      {
        code: 'pt-002',
        checked: true
      },
      {
        code: 'pt-003',
        checked: true
      },
      {
        code: 'pt-004',
        checked: true
      },
      {
        code: 'pt-005',
        checked: true
      },
      {
        code: 'pt-006',
        checked: true
      },
      {
        code: 'pt-007',
        checked: true
      },
      {
        code: 'pt-008',
        checked: true
      },
      {
        code: 'pt-009',
        checked: true
      },
      {
        code: 'pt-010',
        checked: true
      },
      {
        code: 'pt-011',
        checked: true
      },
      {
        code: 'pt-012',
        checked: true
      },
      {
        code: 'pt-013',
        checked: true
      },
      {
        code: 'pt-014',
        checked: true
      },
      {
        code: 'pt-015',
        checked: true
      },
      {
        code: 'pt-016',
        checked: true
      },
      {
        code: 'pt-017',
        checked: true
      },
      {
        code: 'pt-018',
        checked: true
      },
      {
        code: 'pt-019',
        checked: true
      },
      {
        code: 'pt-020',
        checked: true
      }
    ],
    permissions: {
      creating_invoices_and_payouts: true,
      // registry_export: true,
      manage_api_settings: true,
      view_analytics: true,
      view_finance: true
    }
  },
  settings: {
    time_format: TimeFormats.TWENTY_FOUR_HOURS,
    date_format: DateFormats.EU_DATE_FORMAT,
    number_format: {
      decimals_separator: NumberSeparators.COMMA,
      digits_separator: NumberSeparators.SPACE
    },
    currency_format: {
      sign: false,
      left_position: false
    },
    timezone: 'America/Mexico_City'
  }
}

const user_list_mock = [
  {
    id: 113,
    name: 'Ivan Ivanovich',
    email: 'tstark@gmail.com',
    company: null,
    registered_date: '2025-08-29T10:10:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        {
          code: 'pt-001',
          checked: true
        },
        {
          code: 'pt-002',
          checked: true
        },
        {
          code: 'pt-003',
          checked: true
        }
      ],
      permissions: {
        creating_invoices_and_payouts: false,
        // registry_export: true,
        manage_api_settings: false,
        view_analytics: false,
        view_finance: false
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'America/Ojinaga'
    }
  },
  {
    id: 114,
    name: 'Semen Semenovich',
    email: 'jsmark@gmail.com',
    company: null,
    registered_date: '2025-09-16T14:37:18Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        {
          code: 'pt-001',
          checked: true
        },
        {
          code: 'pt-017',
          checked: true
        },
        {
          code: 'pt-019',
          checked: false
        }
      ],
      permissions: {
        creating_invoices_and_payouts: true,
        // registry_export: true,
        manage_api_settings: true,
        view_analytics: false,
        view_finance: false
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'America/Tijuana'
    }
  },
  {
    id: 115,
    name: 'Teodor Musetti',
    email: 'msaudio@gmail.com',
    company: null,
    registered_date: '2025-06-14T10:10:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        {
          code: 'pt-001',
          checked: true
        },
        {
          code: 'pt-002',
          checked: true
        },
        {
          code: 'pt-003',
          checked: true
        },
        {
          code: 'pt-004',
          checked: true
        },
        {
          code: 'pt-005',
          checked: true
        },
        {
          code: 'pt-006',
          checked: true
        },
        {
          code: 'pt-007',
          checked: true
        },
        {
          code: 'pt-008',
          checked: true
        },
        {
          code: 'pt-009',
          checked: true
        },
        {
          code: 'pt-010',
          checked: true
        },
        {
          code: 'pt-011',
          checked: true
        },
        {
          code: 'pt-012',
          checked: true
        },
        {
          code: 'pt-013',
          checked: true
        },
        {
          code: 'pt-014',
          checked: true
        },
        {
          code: 'pt-015',
          checked: true
        },
        {
          code: 'pt-016',
          checked: true
        },
        {
          code: 'pt-017',
          checked: true
        },
        {
          code: 'pt-018',
          checked: true
        },
        {
          code: 'pt-019',
          checked: true
        },
        {
          code: 'pt-020',
          checked: true
        }
      ],
      permissions: {
        creating_invoices_and_payouts: false,
        // registry_export: false,
        manage_api_settings: true,
        view_analytics: true,
        view_finance: true
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'Asia/Kabul'
    }
  },
  {
    id: 116,
    name: 'Petr Petrovich',
    email: 'petrovich@gmail.com',
    company: null,
    registered_date: '2025-07-01T08:45:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        { code: 'abc-111', checked: true },
        { code: 'abc-222', checked: false }
      ],
      permissions: {
        creating_invoices_and_payouts: true,
        // registry_export: false,
        manage_api_settings: false,
        view_analytics: false,
        view_finance: true
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'Asia/Nicosia'
    }
  },
  {
    id: 117,
    name: 'Olga Sergeevna',
    email: 'olga.serg@example.com',
    company: null,
    registered_date: '2025-05-21T12:30:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        { code: 'xyz-001', checked: false },
        { code: 'xyz-002', checked: true }
      ],
      permissions: {
        creating_invoices_and_payouts: true,
        // registry_export: true,
        manage_api_settings: false,
        view_analytics: false,
        view_finance: false
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'Australia/Hobart'
    }
  },
  {
    id: 118,
    name: 'Maria Ivanova',
    email: 'maria.i@example.com',
    company: null,
    registered_date: '2025-03-11T09:00:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [],
      permissions: {
        creating_invoices_and_payouts: false,
        // registry_export: false,
        manage_api_settings: true,
        view_analytics: true,
        view_finance: false
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: ''
    }
  },
  {
    id: 119,
    name: 'Sergey Kuznetsov',
    email: 'sergey.k@example.com',
    company: null,
    registered_date: '2025-04-19T17:15:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        { code: 'sp-1', checked: true }
      ],
      permissions: {
        creating_invoices_and_payouts: true,
        // registry_export: false,
        manage_api_settings: true,
        view_analytics: false,
        view_finance: true
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'Etc/GMT+10'
    }
  },
  {
    id: 120,
    name: 'Michael åkerfeldt',
    email: 'bwp@example.com',
    company: null,
    registered_date: '2025-02-10T10:10:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        { code: 'sm-123', checked: true },
        { code: 'sm-456', checked: false }
      ],
      permissions: {
        creating_invoices_and_payouts: false,
        // registry_export: true,
        manage_api_settings: true,
        view_analytics: true,
        view_finance: true
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'Europe/Berlin'
    }
  },
  {
    id: 121,
    name: 'Dmitry Arab',
    email: 'vamdimon.d@example.com',
    company: null,
    registered_date: '2025-01-01T00:00:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        { code: 'orl-1', checked: true }
      ],
      permissions: {
        creating_invoices_and_payouts: true,
        // registry_export: true,
        manage_api_settings: false,
        view_analytics: false,
        view_finance: false
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'Europe/Rome'
    }
  },
  {
    id: 122,
    name: 'Natalia Petrova',
    email: 'natalia.p@example.com',
    company: null,
    registered_date: '2025-09-01T20:20:00Z',
    lang: null,
    login_mfa: false,
    user_permissions: {
      salepoints: [
        { code: 'np-001', checked: true },
        { code: 'np-002', checked: true }
      ],
      permissions: {
        creating_invoices_and_payouts: false,
        // registry_export: false,
        manage_api_settings: false,
        view_analytics: false,
        view_finance: true
      }
    },
    settings: {
      time_format: TimeFormats.TWENTY_FOUR_HOURS,
      date_format: DateFormats.EU_DATE_FORMAT,
      number_format: {
        decimals_separator: NumberSeparators.COMMA,
        digits_separator: NumberSeparators.SPACE
      },
      currency_format: {
        sign: false,
        left_position: false
      },
      timezone: 'America/North_Dakota/New_Salem'
    }
  }
]

const notification_settings = {
  type: {
    email: true,
    sms: false
  },
  events: {
    login: true,
    payment_error: true
  }
}

export default {
  credentials_list,
  point_list,
  transaction_list,
  settlement_list,
  user_mock,
  user_list_mock,
  notification_settings
}
